import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'app-table-filter',
    templateUrl: './table-filter.component.html',
    styleUrls: ['./table-filter.component.scss'],
})
export class TableFilterComponent implements OnInit {
    @Input() dataSource: MatTableDataSource<any>;
    @Input() placeholder = 'Search...';
    @Input() label = 'Filter';

    @Output() filterChanged = new EventEmitter<string>();
    @Output() filterCleared = new EventEmitter<void>();

    @ViewChild('filterInput', { static: false }) filterInput: ElementRef<HTMLInputElement>;

    currentFilter = '';

    constructor() {}

    ngOnInit(): void {
        // Component is ready
    }

    applyFilter(event: Event): void {
        const filterValue = (event.target as HTMLInputElement).value;
        this.currentFilter = filterValue.trim().toLowerCase();

        // Apply filter to the data source
        if (this.dataSource) {
            this.dataSource.filter = this.currentFilter;

            // Reset to first page when filtering
            if (this.dataSource.paginator) {
                this.dataSource.paginator.firstPage();
            }
        }

        // Emit the filter change event
        this.filterChanged.emit(this.currentFilter);
    }

    clearFilter(): void {
        this.currentFilter = '';

        // Clear the input field
        if (this.filterInput) {
            this.filterInput.nativeElement.value = '';
        }

        // Clear the data source filter
        if (this.dataSource) {
            this.dataSource.filter = '';

            // Reset to first page
            if (this.dataSource.paginator) {
                this.dataSource.paginator.firstPage();
            }
        }

        // Emit the clear event
        this.filterCleared.emit();
        this.filterChanged.emit('');
    }

    get hasFilter(): boolean {
        return this.currentFilter.length > 0;
    }
}
